export default __webpack_public_path__ + "static/media/google-drive.0f673709.svg";